// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"_60d86b","accordionSummary":"_80cd4e","iconCons":"_cf9d29","iconPros":"_a4099e","avatars":"_cde972","accordionDetails":"_d6e797","link":"_2bb003","row":"_cfa45d"};